<template>
  <div id="Main">
    <div class="htitle" v-if="type!=1">
      <p class="p1">我的信息</p>
    </div>
    <div class="box" v-if="type!=1">
      <div class="inputbox">
        <span class="label">
          <van-icon class="icon" :name="require('../assets/images/service/account_1.png')" />股东代码：
        </span>
        <van-field class="input" :value="shareholderCode" readonly />
      </div>
      <div class="inputbox">
        <span class="label">
          <van-icon class="icon" :name="require('../assets/images/service/user_1.png')" />股东姓名：
        </span>
        <van-field class="input" :value="shareholdeName" readonly />
      </div>
    </div>
    <p class="name">支付信息</p>
    <div class="box" v-if="formdata!=''||this.$route.query.type==2">
      <div class="form">
        <div class="inputbox">
          <div class="title">
            <van-icon class="icon" :name="require('../assets/images/service/account_1.png')" />
            <span v-if="this.$route.query.type!=1">收费项</span>
            <span v-if="this.$route.query.type==1">开户费</span>
          </div>
          <van-field class="input" :value="formdata.bussinessTypeName" readonly type="text" v-if="this.$route.query.type!=2"/>
           <van-field class="input" :value="bussinessTypeName" readonly type="text"  v-if="this.$route.query.type==2"/>
        </div>
        <div class="inputbox">
          <div class="title">
            <van-icon class="icon" :name="require('../assets/images/service/account_1.png')" />
            <span>收费金额</span>
          </div>
          <van-field class="input" :value="formdata.charge" readonly type="text"  v-if="this.$route.query.type!=2"/>
          <van-field class="input" :value="payAmount" readonly type="text"  v-if="this.$route.query.type==2"/>
        </div>
        <div class="inputbox">
          <div class="title">
            <van-icon class="icon" :name="require('../assets/images/service/account_1.png')" />
            <span>收费详情</span>
          </div>
          <p class="inputcontent" v-if="this.$route.query.type!=2">{{formdata.content}}</p>
          <p class="inputcontent" v-if="this.$route.query.type==2">{{suggestion}}</p>
        </div>
      </div>
    </div>

 
    <van-button round type="info" v-if="intercept" class="submit" @click="getplyPay">立即支付</van-button>
    <van-button round type="info" v-else class="submit" @click="getNopay">重新支付</van-button>
  </div>
</template>
<script>
import axiosPost from "../libs/moudle/index.js";
import { plyPay } from "../libs/api/index.js";
export default {
  components: {},
  data() {
    return {
      formdata: "",
      /*, 表单数据 */
      openId: "",
      id: "",
      intercept: true,
      shareholderCode: "",
      shareholdeName: "",
      wxdata: "",
      type: "",
      suggestion:'',
      payAmount:'',
      bussinessTypeName:'实名认证'
    };
  },
  methods: {
    getplyPay() {
      if (this.type == 0) {
        let t = this;
        this.$toast.loading({
          message: "支付中...",
          forbidClick: true,
          duration: 0
        });
        let data = {
          bussinessapplyId: this.id
        };
        if (this.type != 1) {
          data.shareholdeCode = this.shareholderCode;
          data.shareholdeName = this.shareholdeName;
        } // eslint-disable-next-line no-debugger
        axiosPost
          .plyPay(data)
          .then(res => {
            if (res.data.code == 200) {
              this.wxdata = JSON.parse(res.data.data);
              plyPay(this.wxdata, function(res) {
                setTimeout(function() {
                  if (res) {
                    t.$toast.clear();
                    t.$router.push({
                      path: "/msghtml",
                      query: {
                        text: "支付成功"
                      }
                    });
                  } else {
                    this.$toast({
                      duration: 4000,
                      message: "支付失败，请重新支付"
                    });
                    t.intercept = false;
                  }
                }, 1000);
              });
            } else {
              this.$toast({ duration: 4000, message: res.data.msg });
            }
          })
          .catch(res => {
            window.console.log(res);
          });
      }
      if (this.type == 1) {
        let t = this;
        this.$toast.loading({
          message: "支付中...",
          forbidClick: true,
          duration: 0
        });
        let data = {
          id: this.id,
          openId: this.openId
        };

        axiosPost
          .plyPays(data)
          .then(res => {
            if (res.data.code == 200) {
              this.wxdata = JSON.parse(res.data.data);
              plyPay(this.wxdata, function(res) {
                setTimeout(function() {
                  if (res) {
                    t.$toast.clear();
                    t.$router.push({
                      path: "/msghtml",
                      query: {
                        text: "支付成功"
                      }
                    });
                  } else {
                    this.$toast({
                      duration: 4000,
                      message: "支付失败，请重新支付"
                    });
                    t.intercept = false;
                  }
                }, 1000);
              });
            } else {
              this.$toast({ duration: 4000, message: res.data.msg });
            }
          })
          .catch(res => {
            window.console.log(res);
          });
      }

      if (this.$route.query.type == 2) {
        let t = this;
        this.$toast.loading({
          message: "支付中...",
          forbidClick: true,
          duration: 0
        });
        let data = {
          id: this.id,
          openId: this.openId
        };

        axiosPost
          .plyPayss(data)
          .then(res => {
            if (res.data.code == 200) {
              this.wxdata = JSON.parse(res.data.data);
              plyPay(this.wxdata, function(res) {
                setTimeout(function() {
                  if (res) {
                    t.$toast.clear();
                    t.$router.push({
                      path: "/msghtml",
                      query: {
                        text: "支付成功"
                      }
                    });
                  } else {
                    this.$toast({
                      duration: 4000,
                      message: "支付失败，请重新支付"
                    });
                    t.intercept = false;
                  }
                }, 1000);
              });
            } else {
              this.$toast({ duration: 4000, message: res.data.msg });
            }
          })
          .catch(res => {
            window.console.log(res);
          });
      }
    },
    getNopay() {
      let t = this;
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        duration: 0
      });
      axiosPost
        .getNopay({
          bussinessapplyId: this.id
        })
        .then(res => {
          window.console.log(res.data.data);
          if (res.data.code == 200) {
            window.console.log(res.data.data);
            this.wxdata = JSON.parse(res.data.data.orderInfo);
            plyPay(this.wxdata, function(res) {
              setTimeout(function() {
                if (res) {
                  t.$toast.clear();
                  t.$router.push({
                    path: "/msghtml",
                    query: {
                      text: "支付成功"
                    }
                  });
                } else {
                  this.$toast({
                    duration: 4000,
                    message: "支付失败，请重新支付"
                  });
                  t.intercept = false;
                }
              }, 1000);
            });
          } else {
            this.$toast({ duration: 4000, message: res.data.msg });
          }
        })
        .catch(res => {
          window.console.log(res);
        });
    },
    getShare() {
      axiosPost
        .getOpenId({
          openId: this.openId
        })
        .then(res => {
          /* 验证是否实名 */
          window.console.log(res.data);
          if (res.data.code == 200) {
            this.shareholderCode = res.data.data.shareholderCode;
            this.shareholdeName = res.data.data.realName;
          } else {
            this.$toast({ duration: 4000, message: res.data.msg });
          }
        })
        .catch(res => {
          window.console.log(res);
        });
    },
    getdata() {
      axiosPost
        .getPaydetails({
          id: this.id
        })
        .then(res => {
          /* 获取支付收费详情 */
          window.console.log(res.data);
          if (res.data.code == 200) {
            this.formdata = res.data.data;
          } else {
            this.$toast({ duration: 4000, message: res.data.msg });
          }
        })
        .catch(res => {
          window.console.log(res);
        });
    },
    getopenidaccount() {
      axiosPost
        .getopenidaccount({
          openId: this.openId
        })
        .then(res => {
          /* 获取支付收费详情 */
          window.console.log(res.data);
          if (res.data.code == 200) {
            if (res.data.data.payAmount) {
              this.formdata = {
                bussinessTypeName: "开户申请",
                charge: res.data.data.payAmount,
                content: res.data.data.suggestion
              };
            } else {
              this.$toast("查询失败，请稍后再试！");
              this.$toast({
                duration: 4000,
                message: "查询失败，请稍后再试！"
              });
            }
          } else {
            this.$toast({ duration: 4000, message: res.data.msg });
          }
        })
        .catch(res => {
          window.console.log(res);
        });
    },
    // type=2调用这个接口
    getRealNameInfoById(){
       axiosPost
        .getRealNameInfoById({
          id: this.id
        })
        .then(res => {
          /* 获取支付收费详情 */
          // window.console.log(res.data.data);
          if (res.data.code == 200) {
            this.suggestion = res.data.data.suggestion;
            this.payAmount = res.data.data.payAmount;
          } else {
            this.$toast({ duration: 4000, message: res.data.data.msg });
          }
        })
        .catch(res => {
          window.console.log(res);
        });
    }
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.id = this.$route.query.id; /* 收费业务id详情 */
    window.console.log(this.$route.query.type);
    if (this.$route.query.type && this.$route.query.type == 1) {
      /* 开户 */
      this.type = this.$route.query.type;
      this.getopenidaccount();
    } else {
      /* 其他 */
      this.getShare();//验证是否实名的接口
     
      if( this.$route.query.type!=2){
         this.getdata();//获取下单的数据\
      }
    }

    if(this.$route.query.type == 2){
      this.getRealNameInfoById()
    }
    
  }
};
</script>

<style lang="scss" scoped>
#Main {
  padding: 1.3rem;
  min-height: 100vh;
  background-color: #f2f9ff;

  .loaderbox {
    width: 100%;
    flex-wrap: wrap;
    margin: 1.5rem 0;

    .loaderimg {
      width: 30%;
      padding: 15% 0;
      margin-right: 5%;
      position: relative;
      margin-bottom: 1.5rem;

      .pos {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .htitle {
    margin-bottom: 1rem;
    text-align: left;

    .p1 {
      font-weight: bold;
      color: #161616;
      font-size: 1.8rem;
      line-height: 2.5rem;
    }

    .p2 {
      color: #999999;
      font-size: 1.4rem;
      line-height: 2rem;
    }
  }

  .submit {
    width: 90%;
    display: block;
    margin: 2rem auto;
    background-color: #fa6b6b;
    border: 0;
    box-shadow: 0 3px 8px 1px #e8eaee;
  }

  .form {
    padding-bottom: 3rem;

    .inputbox {
      padding: 1rem 0;
      padding-left: 3rem;

      .input {
        flex: 1;
        padding: 0;
        height: 4rem;
        line-height: 4rem;
        border-bottom: 1px solid #e0dfdf;

        &:not(:last-child):after {
          display: none;
        }
      }

      .select {
        color: #a0a0a0;
      }
      .inputcontent {
        padding: 0;
        line-height: 2rem;
        text-align: left;
        border-bottom: 1px solid #e0dfdf;
        font-size: 1.35rem;
        color: #333;
        padding-bottom: 1rem;
      }
    }

    .title {
      text-align: left;
      line-height: 2.5rem;
      margin-left: -2.3rem;

      span {
        font-weight: bold;
        font-size: 1.6rem;
        color: #333;
      }

      .ico {
        color: #fa6b6b;
        display: inline-block;
        margin-left: 5px;
      }

      .icon {
        vertical-align: -0.25rem;
        margin-right: 0.8rem;
      }
    }
  }

  .box {
    background-color: #fff;
    border-radius: 8px;
    padding: 0 1rem;
    margin-bottom: 1rem;
    box-shadow: 0 2px 5px 1px #e4ebfa;

    & > .inputbox {
      display: flex;
      margin-bottom: 0.8rem;
      margin-left: auto;
      margin-right: auto;
      border-bottom: 1px solid #ebebeb;
      padding: 1rem 0;
      line-height: 2.4rem;

      &:last-child {
        margin-bottom: 0;
        border-bottom: 0;
      }

      .input {
        padding: 0 1rem 0 0;
        flex: 1;
        line-height: 2.4rem;
        font-size: 1.6rem;
      }

      .label {
        color: #4f1c1c;
        font-size: 1.6rem;
        margin-right: 0.6rem;
      }

      .icon {
        vertical-align: -0.2rem;
        margin-right: 0.6rem;
      }
    }

    .warning {
      font-size: 1.4rem;
      color: #fa6b6b;
      text-align: left;
      margin-bottom: 1rem;
    }
  }

  .name {
    text-align: left;
    font-size: 1.8rem;
    color: #333;
    line-height: 3.5rem;
    padding: 0.6rem 0;
    font-weight: bold;
  }
}
</style>
